// extracted by mini-css-extract-plugin
export default {"root":"root--6be0a60","input":"input--cb585f8"};